export const tabInit = () => {
    if (document.querySelector("main").classList.contains("home")) {
        let pare = document.querySelector(".newnews__innerBlockCnt"),
            cats = pare.querySelectorAll(".newnews__innerBlockCntCatsCat"),
            rows = pare.querySelectorAll(".newnews__innerBlockCntRowsRow");

        cats.forEach(cat => {
            cat.addEventListener("click", (e) => {

                cats.forEach(cat2 => {
                    cat2.classList.remove("crnt")
                })

                e.currentTarget.classList.add("crnt")

                rows.forEach(row => {
                    row.classList.remove("crnt")

                    if (row.classList.contains(cat.dataset.cat)) {
                        row.classList.add("crnt")
                    }
                })
            })
        });
    }
}